import { render } from "./Unlimited.vue?vue&type=template&id=6cb0fca0&scoped=true&ts=true"
import script from "./Unlimited.vue?vue&type=script&lang=ts"
export * from "./Unlimited.vue?vue&type=script&lang=ts"

import "./Unlimited.vue?vue&type=style&index=0&id=6cb0fca0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb0fca0"]])

export default __exports__